import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import VersionChecker from './components/VersionChecker';

// Pages
import Login from './pages/Login';
import Register from './pages/Register';
import ResetPassword from './pages/ResetPassword';
import SilverRegister from './pages/SilverRegister';
import GoldRegister from './pages/GoldRegister';
import SCCRegister from './pages/SCCRegister';
import PriveRegister from './pages/PriveRegister';
import Dashboard from './pages/Dashboard';
import Profile from './pages/Profile';
import News from './pages/News';
import WealthLuxury from './pages/WealthLuxury';
import PriveFineDining from './pages/PriveFineDining';
import Events from './pages/Events';
import Travel from './pages/Travel';
import GiftOfGold from './pages/GiftOfGold';
import SupercarClub from './pages/SupercarClub';
import WealthProtect from './pages/WealthProtect';
import Vaults from './pages/Vaults';
import PrivateInvitations from './pages/PrivateInvitations';
import BullionExchange from './pages/BullionExchange';
import DesignerJewellery from './pages/DesignerJewellery';
import LuxuryTravelConcierge from './pages/LuxuryTravelConcierge';
import WellnessRetreats from './pages/WellnessRetreats';
import LeadingLadiesCircle from './pages/LeadingLadiesCircle';
import AITutor from './pages/AITutor';
import PrimeRealEstate from './pages/PrimeRealEstate';
import WealthFinanceFiduciary from './pages/WealthFinanceFiduciary';
import InsuranceWealthProtection from './pages/InsuranceWealthProtection';
import LeadershipInvestments from './pages/LeadershipInvestments';
import Concierge from './pages/Concierge';
import Reservation from './pages/Reservation';
import Restaurant from './pages/Restaurant';
import BespokeAuctions from './pages/BespokeAuctions';
import ProductDetail from './pages/ProductDetail';
import Advisory from './pages/Advisory';
import Trade from './pages/Trade';
import Upgrade from './pages/Upgrade';
import Network from './pages/Network';
import GoldOnline from './pages/GoldOnline';
import BullionInsurance from './pages/BullionInsurance';
import PriveWealthClub from './pages/PriveWealthClub';
import PriveLounge from './pages/PriveLounge';
import WealthAdvisory from './pages/WealthAdvisory';
import BlogPost from './pages/BlogPost';
import AdminDashboard from './pages/AdminDashboard';
import PriveShop from './pages/PriveShop';
import ContentAdminLogin from './pages/ContentAdminLogin';
import ContentAdminDashboard from './pages/ContentAdminDashboard';
import RestaurantBooking from './pages/RestaurantBooking';
import RestaurantOrder from './pages/RestaurantOrder';
import RestaurantOrders from './pages/RestaurantOrders';
import KitchenDashboard from './pages/KitchenDashboard';
import RestaurantAdminEnhanced from './pages/RestaurantAdminEnhanced';
import RestaurantAdminLogin from './pages/RestaurantAdminLogin';
import LondonVIPAdminDashboard from './pages/LondonVIPAdminDashboard';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  return user ? children : <Navigate to="/login" replace />;
};

function App() {
  return (
    <AuthProvider>
      <VersionChecker />
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/register" element={<Register />} />
          <Route path="/register/silver" element={<SilverRegister />} />
          <Route path="/register/gold" element={<GoldRegister />} />
          <Route path="/register/scc" element={<SCCRegister />} />
          <Route path="/register/prive" element={<PriveRegister />} />
          
          {/* Admin Routes */}
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/content-admin-login" element={<ContentAdminLogin />} />
          <Route path="/content-admin" element={<ContentAdminDashboard />} />
          <Route path="/restaurant-admin-login" element={<RestaurantAdminLogin />} />
          <Route path="/london-vip-admin" element={<LondonVIPAdminDashboard />} />

          {/* Protected Routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/news"
            element={
              <ProtectedRoute>
                <News />
              </ProtectedRoute>
            }
          />
          <Route
            path="/wealth-luxury"
            element={
              <ProtectedRoute>
                <WealthLuxury />
              </ProtectedRoute>
            }
          />
          <Route
            path="/prive-fine-dining"
            element={
              <ProtectedRoute>
                <PriveFineDining />
              </ProtectedRoute>
            }
          />
          <Route
            path="/events"
            element={
              <ProtectedRoute>
                <Events />
              </ProtectedRoute>
            }
          />
          <Route
            path="/travel"
            element={
              <ProtectedRoute>
                <Travel />
              </ProtectedRoute>
            }
          />
          <Route
            path="/gift-of-gold"
            element={
              <ProtectedRoute>
                <GiftOfGold />
              </ProtectedRoute>
            }
          />
          <Route
            path="/supercar-club"
            element={
              <ProtectedRoute>
                <SupercarClub />
              </ProtectedRoute>
            }
          />
          <Route
            path="/wealth-protect"
            element={
              <ProtectedRoute>
                <WealthProtect />
              </ProtectedRoute>
            }
          />
          <Route
            path="/vaults"
            element={
              <ProtectedRoute>
                <Vaults />
              </ProtectedRoute>
            }
          />
          <Route
            path="/private-invitations"
            element={
              <ProtectedRoute>
                <PrivateInvitations />
              </ProtectedRoute>
            }
          />
          <Route
            path="/bullion-exchange"
            element={
              <ProtectedRoute>
                <BullionExchange />
              </ProtectedRoute>
            }
          />
          <Route
            path="/designer-jewellery"
            element={
              <ProtectedRoute>
                <DesignerJewellery />
              </ProtectedRoute>
            }
          />
          <Route
            path="/luxury-travel-concierge"
            element={
              <ProtectedRoute>
                <LuxuryTravelConcierge />
              </ProtectedRoute>
            }
          />
          <Route
            path="/wellness-retreats"
            element={
              <ProtectedRoute>
                <WellnessRetreats />
              </ProtectedRoute>
            }
          />
          <Route
            path="/leading-ladies-circle"
            element={
              <ProtectedRoute>
                <LeadingLadiesCircle />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ai-tutor"
            element={
              <ProtectedRoute>
                <AITutor />
              </ProtectedRoute>
            }
          />
          <Route
            path="/prime-real-estate"
            element={
              <ProtectedRoute>
                <PrimeRealEstate />
              </ProtectedRoute>
            }
          />
          <Route
            path="/wealth-finance-fiduciary"
            element={
              <ProtectedRoute>
                <WealthFinanceFiduciary />
              </ProtectedRoute>
            }
          />
          <Route
            path="/insurance-wealth-protection"
            element={
              <ProtectedRoute>
                <InsuranceWealthProtection />
              </ProtectedRoute>
            }
          />
          <Route
            path="/leadership-investments"
            element={
              <ProtectedRoute>
                <LeadershipInvestments />
              </ProtectedRoute>
            }
          />
          <Route
            path="/concierge"
            element={
              <ProtectedRoute>
                <Concierge />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reservation"
            element={
              <ProtectedRoute>
                <Reservation />
              </ProtectedRoute>
            }
          />
          <Route
            path="/restaurant"
            element={
              <ProtectedRoute>
                <Restaurant />
              </ProtectedRoute>
            }
          />
          <Route
            path="/bespoke-auctions"
            element={
              <ProtectedRoute>
                <BespokeAuctions />
              </ProtectedRoute>
            }
          />
          <Route
            path="/product/:id"
            element={
              <ProtectedRoute>
                <ProductDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/advisory"
            element={
              <ProtectedRoute>
                <Advisory />
              </ProtectedRoute>
            }
          />
          <Route
            path="/trade"
            element={
              <ProtectedRoute>
                <Trade />
              </ProtectedRoute>
            }
          />
          <Route
            path="/upgrade"
            element={
              <ProtectedRoute>
                <Upgrade />
              </ProtectedRoute>
            }
          />
          <Route
            path="/network"
            element={
              <ProtectedRoute>
                <Network />
              </ProtectedRoute>
            }
          />
          <Route
            path="/gold-online"
            element={
              <ProtectedRoute>
                <GoldOnline />
              </ProtectedRoute>
            }
          />
          <Route
            path="/bullion-insurance"
            element={
              <ProtectedRoute>
                <BullionInsurance />
              </ProtectedRoute>
            }
          />
          <Route
            path="/prive-wealth-club"
            element={
              <ProtectedRoute>
                <PriveWealthClub />
              </ProtectedRoute>
            }
          />
          <Route
            path="/prive-lounge"
            element={
              <ProtectedRoute>
                <PriveLounge />
              </ProtectedRoute>
            }
          />
          <Route
            path="/prive-shop"
            element={
              <ProtectedRoute>
                <PriveShop />
              </ProtectedRoute>
            }
          />
          <Route
            path="/wealth-advisory"
            element={
              <ProtectedRoute>
                <WealthAdvisory />
              </ProtectedRoute>
            }
          />
          <Route
            path="/blog/:slug"
            element={
              <ProtectedRoute>
                <BlogPost />
              </ProtectedRoute>
            }
          />
          <Route
            path="/restaurant-booking"
            element={
              <ProtectedRoute>
                <RestaurantBooking />
              </ProtectedRoute>
            }
          />
          <Route
            path="/restaurant-order"
            element={
              <ProtectedRoute>
                <RestaurantOrder />
              </ProtectedRoute>
            }
          />
          <Route
            path="/restaurant-orders"
            element={
              <ProtectedRoute>
                <RestaurantOrders />
              </ProtectedRoute>
            }
          />
          <Route
            path="/kitchen-dashboard"
            element={<KitchenDashboard />}
          />
          <Route
            path="/restaurant-admin"
            element={<RestaurantAdminEnhanced />}
          />

          {/* Catch all - redirect to splash */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
